module.exports = __webpack_public_path__ + "img/logoText.94cbd2ee.png";